import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { HelpdeskToolkitRoutingModule } from "@dtm-frontend/helpdesk-toolkit-lib";
import { DTM_AUTH_GUARD_REQUIRED_ROLES, DtmAuthGuard, NOT_AUTHORIZED_ROUTE } from "@dtm-frontend/shared/auth";
import { NotAuthorizedComponent } from "@dtm-frontend/shared/ui";

const routes: Routes = [
    {
        path: NOT_AUTHORIZED_ROUTE,
        component: NotAuthorizedComponent,
        canActivate: [DtmAuthGuard],
    },
    { path: "**", redirectTo: "/" },
];

@NgModule({
    imports: [RouterModule.forRoot(routes), HelpdeskToolkitRoutingModule],
    providers: [
        {
            provide: DTM_AUTH_GUARD_REQUIRED_ROLES,
            useValue: [],
        },
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
